import React, { useState } from "react";
import '../../assets/css/video/modal.css';
// import '../../assets/css/video/mobile.css';
import YtBtn from '../../assets/img/icon/YouTube_logo_03.png';
import DisYtBtn from '../../assets/img/icon/YouTube_logo_bk.png';
import VideoModal from "./VideoModal";
import dateSetting from '../../utils/dateSetting';
import { intervalLogging, stopLogging } from "../common/Logger";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";

export default function RecentGameModal(props){
    const [cookies] = useCookies(['hiball_token']);
    const location = useLocation();

    const [modalState, setModalState] = useState(false);

    const openModal = (event) => {
        let gameInfoId = event.currentTarget.id;
        let playerObj = {
            playerType: props.type,
            playerId: props.playerId,
            gameInfoId: gameInfoId
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        setModalState(true);
    }

    const closeModal = () => {
        let playerObj = {
            playerType: props.type,
            playerId: props.playerId,
        }
        stopLogging();
        intervalLogging(location.pathname, cookies['hiball_token'], playerObj);
        setModalState(false);
    }

    //만약 타석이 0일경우 유튜브 버튼 비활성화
    return (
        <>
            {props.tpa == 0 
                ? <img className="ytBtn" 
                src={DisYtBtn} style={{pointerEvents:"none"}}
                alt="#" height="28px" id={props.gameInfoId}/>
                : <img className="ytBtn" 
                src={YtBtn} onClick={openModal}
                alt="#" height="28px" id={props.gameInfoId}/>
            }
            {props.type == 'batter' 
                ? <VideoModal content={"recentGame"} modalState={modalState} closeModal={closeModal}
                    parameterSet={{"gameInfoIds":[props.gameInfoId+"_broadCast"], "batterIds":[props.playerId*1], "playerIds":[props.playerId*1], "teamId":props.teamId*1, "position":props.type}}
                  />
                : <VideoModal content={"recentGame"} modalState={modalState} closeModal={closeModal} 
                    parameterSet={{"gameInfoIds":[props.gameInfoId+"_broadCast"], "pitcherIds":[props.playerId*1], "playerIds":[props.playerId*1], "teamId":props.teamId*1, "position":props.type}}
                  />
            }
        </>
    );
}